import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { PreOrderAddTruckComponent } from "../pre-order-add-truck/pre-order-add-truck.component";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { TruckOwnerService } from "../truck-owner.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonServices } from "src/app/common.services";
import { Socket } from "ngx-socket-io";
import { PreOrderBidRateComponent } from "../pre-order-bid-rate/pre-order-bid-rate.component";
import { Subscription } from 'rxjs';
import { QuoteBidComponent } from '../quote-bid/quote-bid.component';

declare var google: any;

@Component({
  selector: "app-pre-orders",
  templateUrl: "./pre-orders.component.html",
  styleUrls: ["./pre-orders.component.css"],
})
export class PreOrdersComponent implements OnInit, AfterViewInit {
  preorderType: any = "-1";
  token: any;
  wo1: boolean = true;
  wo2: boolean = false;
  wo3: boolean = false;
  matdialogre!: MatDialogRef<PreOrderAddTruckComponent>;
  MatDialogRef!: MatDialogRef<DeleteDialogComponent>;
  profilePic: any = "";
  userName: any = "";
  truckOwner: any;
  timeRemaining: number = 30 * 60; // 30 minutes in seconds
  timer: any;
  formattedTime: string = "30:00";
  workOrderId: any = -1;
  page: any = 1;
  perPage: any = 10;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  @ViewChild("newItem") newItem!: ElementRef;
  @ViewChild("fromInput") fromInput!: ElementRef;
  @ViewChild("toInput") toInput!: ElementRef;
  
  fromLat: any = '';
  fromLng: any = '';
  toLat: any = '';
  toLng: any = '';
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  preOrderData: any = [];
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  truckCategory: any = [];
  truckCategoryMap: { [key: string]: string } = {}; // Holds the mapping of IDs to names
  loading: boolean = false;
  selectedData: any;
  trucksList: any = [];
  bidData: any = [];
  bid_list: boolean = false;
  socketTimer: any;
  intervalId: any; // Declare a property to store the interval ID
  isAddTruckDisabled: boolean = false;
  socketData: any;
  submittedBidRate: number | null = null;
  bidRateData: any = null;
  bidRateId: string = '';
  currentTime = Date.now();
  selectedWorkOrder: any = null;
  isLoading: boolean = false;
  progress: number = 0;
  lowestBidRate: number | null = null;
  currentLowestBidRate: number | null = null;
  finalizingResults: boolean = false;
  woSocketSubs: Subscription | null = null;
  activeOrdersSocketSubs: Subscription | null = null;
  apiSubscription: Subscription | null = null;
  activeQuoteSearchForm!: FormGroup;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private matDialog: MatDialog,
    private dialog: MatDialog,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar,
    private commonService: CommonServices,
    private socket: Socket,
    private fb: FormBuilder
  ) {
    this.socket.connect(); // Explicitly connect if needed
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    let triptype = "preOrders";
    sessionStorage.setItem("tripType", triptype);
    sessionStorage.setItem("preorder", "true");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    
    this.activeQuoteSearchForm = this.fb.group({
      from: [""],
      to: [""],
      category: [""]
    });

    this.activeQuoteSearchForm.get("from")?.valueChanges.subscribe((value) => {
      if (!value) {
        this.fromLat = "";
        this.fromLng = "";
      }
    });

    this.activeQuoteSearchForm.get("to")?.valueChanges.subscribe((value) => {
      if (!value) {
        this.toLat = "";
        this.toLng = "";
      }
    });

    this.getProfile();
    this.getTruckCategory();
    setInterval(() => {
      this.currentTime = Date.now();
    }, 1000);

    this.route.queryParams.subscribe(params => {
      if (params['workOrderId']) {
        this.workOrderId = params['workOrderId'];
        this.fetchAndBid(this.workOrderId);
      } else {
        this.pagination(1);
      }
    });

    this.activeOrdersSocketSubs = this.commonService
      .getPublishedEvent("activeOrders")
      .subscribe({
        next: (data: any) => {
          if (data) {
            if (this.preorderType === 'Quote' || this.preorderType === 'All') {
              this.quoteList(this.workOrderId);
            }
          }
        },
        error: (error) => {
          console.error("activeOrders socket error:", error);
        }
      });
  }

  ngAfterViewInit(): void {
    if (this.preorderType === 'Quote') {
      this.initAutocomplete();
    }
  }

  initAutocomplete(): void {
    setTimeout(() => {
      if (this.fromInput && this.fromInput.nativeElement && this.toInput && this.toInput.nativeElement) {
        const options = {
          componentRestrictions: { country: "in" },
        };
        const fromAutocomplete = new google.maps.places.Autocomplete(
          this.fromInput.nativeElement,
          options
        );
        const toAutocomplete = new google.maps.places.Autocomplete(
          this.toInput.nativeElement,
          options
        );

        google.maps.event.addListener(fromAutocomplete, "place_changed", () => {
          const place = fromAutocomplete.getPlace();
          this.fromLat = place?.geometry?.location?.lat() || '';
          this.fromLng = place?.geometry?.location?.lng() || '';
          this.activeQuoteSearchForm.patchValue({ from: this.fromInput.nativeElement.value });
        });

        google.maps.event.addListener(toAutocomplete, "place_changed", () => {
          const place = toAutocomplete.getPlace();
          this.toLat = place?.geometry?.location?.lat() || '';
          this.toLng = place?.geometry?.location?.lng() || '';
          this.activeQuoteSearchForm.patchValue({ to: this.toInput.nativeElement.value });
        });
      }
    }, 500);
  }

  fetchAndBid(woId: string) {
    this.loading = true;
    this.services.getPreOrder(this.token, woId, this.perPage, 1).subscribe(
      (response: any) => {
        const dataArray = response.body.data.data;
        if (dataArray && dataArray.length) {
          const preorder = dataArray[0];
          this.bid(preorder);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.error('Error fetching work order for bidding:', error);
      }
    );
  }

  search(value: any) {
    if (value != "") {
      this.startPage = 1;
      this.search_btn = false;
      this.clear_btn = true;
      this.preOrderList(value);
    }
  }

  getTruckCategory() {
    this.services.getCategory().subscribe(
      (response: any) => {
        if (response && response.data && Array.isArray(response.data)) {
          this.truckCategory = [...response.data]; // Populate all categories

          // Create a mapping of IDs to names for quick lookups
          this.truckCategoryMap = this.truckCategory.reduce(
            (map: any, category: any) => {
              map[category._id] = category.truck_category_name;
              return map;
            },
            {}
          );
        }
      },
      (error) => { }
    );
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.previousValue.length > previousLength && this.clear_btn) {
      this.callApi();
      this.search_btn = true;
      this.clear_btn = false;
    }
    this.isInputValid = value.length >= 3;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
      case 3:
        if (value.length === 2 && this.lengthState !== 2) {
          this.lengthState = 2;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      default:
        if (value.length >= 2) {
          this.lengthState = 0;
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
    }
  }

  private callApi() {
    this.workOrderId = -1;
    this.fetch_page = 0;
    this.pagination(1);
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.search_btn = true;
    this.clear_btn = false;
    this.workOrderId = -1;
    this.preOrderList(this.workOrderId);
  }

  preOrderList(value: any) {
    this.loading = true;
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    this.apiSubscription = this.services
      .getPreOrder(this.token, value, this.perPage, this.startPage)
      .subscribe(
        (response: any) => {
          if (this.preorderType !== "-1") return;
          this.preOrderData = response.body.data.data;
          this.document_array.push(response.body.data.meta);
          this.last_page = response.body.data.meta.lastPage;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          if (error.status == 404) {
            return;
          }

          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  quoteList(value: any) {
    this.loading = true;
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }

    const from_lat = this.fromLat || '';
    const from_long = this.fromLng || '';
    const to_lat = this.toLat || '';
    const to_long = this.toLng || '';
    const truck_category = this.activeQuoteSearchForm.get('category')?.value || '';

    this.apiSubscription = this.services
      .getActiveOrders(this.token, value, this.startPage, from_lat, from_long, to_lat, to_long, truck_category)
      .subscribe(
        (response: any) => {
          if (this.preorderType !== "Quote" && this.preorderType !== "All") return;
          if (this.preorderType === 'All') {
            const activeWO = response.body.data.activeWorkOrders || [];
            const activeQuotes = response.body.data.todaysActiveQuotes || [];
            this.preOrderData = [...activeWO, ...activeQuotes];
          } else {
            this.preOrderData = response.body.data.todaysActiveQuotes || [];
          }
          if (response.body.data.meta) {
            this.document_array.push(response.body.data.meta);
            this.last_page = response.body.data.meta.lastPage;
          } else {
            this.last_page = 1;
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          if (error.status == 404) {
            this.preOrderData = [];
            return;
          }

          if (error.error.message === "jwt malformed" || error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  getSingleWorkOrderById(woId: string): void {
    this.loading = true;
    this.services
      .getPreOrder(this.token, woId, this.perPage, this.startPage)
      .subscribe(
        (response: any) => {
          console.log("response.body", response.body.data.data[0])
          const dataArray = response.body.data.data;
          if (dataArray && dataArray.length) {
            console.log("1sed")
            this.selectedWorkOrder = dataArray[0]; // Store this locally for reuse
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          if (error.status == 404) return;

          if (["jwt malformed", "jwt expired"].includes(error.error.message)) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }

          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  acceptBid(item: any): void {
    const data = {
      workorder_id: item._id,
      truckowner_bid_status: 'accepted',
    };
    this.services.rejectedBid(data, this.token).subscribe(
      (response: any) => {
        this.snackBar.open("Bid accepted successfully", "Success", {
          duration: 3000,
        });
        this.selectedData = item;
        this.workOrderId = item._id;
      },
      (error) => {
        this.loading = false;
        if (error.status == 404) return;
        if (
          error.error.message === 'jwt malformed' ||
          error.error.message === 'jwt expired'
        ) {
          this.router.navigateByUrl('/');
          sessionStorage.clear();
          return;
        }
        this.snackBar.open(error.error.message, 'Fail', {
          duration: 5000,
        });
      }
    );
  }

  RejectPreorder(item: any, type?: any) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        data: 'reject-bid',
        item: item,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.event === 'Success') {
        this.loading = true;
        const data = {
          workorder_id: item._id,
          truckowner_bid_status: type,
        };
        this.services.rejectedBid(data, this.token).subscribe(
          (response: any) => {
            this.snackBar.open(response.body.message, 'Fail', {
              duration: 3000,
            });
            this.preOrderList(this.workOrderId);
          },
          (error) => {
            this.loading = false;
            if (error.status == 404) return;
            if (
              error.error.message === 'jwt malformed' ||
              error.error.message === 'jwt expired'
            ) {
              this.router.navigateByUrl('/');
              sessionStorage.clear();
            }
            this.snackBar.open(error.error.message, 'Fail', {
              duration: 5000,
            });
          }
        );
      }
    });
  }

  openQuoteBidDialog(item: any, participatedPrice: any, participatedTruckNumber: any, participatedDriverRefId: any, participatedBidId?: any) {
    const dialogRef = this.dialog.open(QuoteBidComponent, {
      width: "40vw",
      autoFocus: false,
      data: { 
        quoteId: item._id,
        metadata: { quote_id: item.trip_id },
        categoryId: item.truck_category?._id || item.truck_category,
        expiresAt: item.quote_expiry_time,
        participatedPrice: participatedPrice,
        participatedTruckNumber: participatedTruckNumber,
        participatedDriverRefId: participatedDriverRefId,
        participatedBidId: participatedBidId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
        this.quoteList(this.workOrderId);
      }
    });
  }

  ngOnDestroy() {
    // Clear the timer when the component is destroyed to prevent memory leaks
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.woSocketSubs) {
      this.woSocketSubs.unsubscribe();
    }
    if (this.activeOrdersSocketSubs) {
      this.activeOrdersSocketSubs.unsubscribe();
    }
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    sessionStorage.removeItem("preorder");
  }

  startTimer() {
    // Clear any existing timer to prevent multiple intervals
    if (this.timer) {
      clearInterval(this.timer);
    }

    // Reset the timeRemaining to 30 minutes each time
    this.timeRemaining = 30 * 60;
    this.formattedTime = this.formatTime(this.timeRemaining);

    // Update the timer every second
    this.timer = setInterval(() => {
      this.timeRemaining--;
      this.formattedTime = this.formatTime(this.timeRemaining);

      if (this.timeRemaining <= 0) {
        clearInterval(this.timer);
        this.formattedTime = "00:00"; // Stop at 00:00
      }
    }, 1000);
  }

  // Format time as MM:SS
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  }

  getTripsList(selectedPreOrderType: any) {
    this.preorderType = selectedPreOrderType;
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    if (this.preorderType == "-1") {
      this.wo1 = true;
      this.wo2 = false;
      this.wo3 = false;
      this.bid_list = false;
      this.bidData = [];
      this.preOrderList(this.workOrderId);
    } else if (this.preorderType == "Quote" || this.preorderType == "All") {
      this.wo1 = true;
      this.wo2 = false;
      this.wo3 = false;
      this.bid_list = false;
      this.bidData = [];
      this.quoteList(this.workOrderId);
      if (this.preorderType == "Quote") {
        this.initAutocomplete();
      }
    }
  }

  bid(item: any, type?: any) {
    if (item.trip_status === 'quote') {
      this.services.getQuoteBidStatus(this.token, item._id).subscribe(
        (res: any) => {
          let participatedPrice = '';
          let participatedTruckNumber = '';
          let participatedDriverRefId = '';
          let participatedBidId = '';
          if (res.body?.data && res.body.data.length > 0) {
            participatedPrice = res.body.data[0].price;
            participatedTruckNumber = res.body.data[0].truck_id?.truck_number || '';
            participatedDriverRefId = res.body.data[0].driver_ref_id || '';
            participatedBidId = res.body.data[0]._id || '';
          }
          this.openQuoteBidDialog(item, participatedPrice, participatedTruckNumber, participatedDriverRefId, participatedBidId);
        },
        (err) => {
          this.openQuoteBidDialog(item, '', '', '', '');
        }
      );
      return;
    }

    this.socketTimer = "";
    this.workOrderId = item._id;
    this.selectedData = item;
    console.log("selectedData", this.selectedData)

    this.getBidRate();
    // Clear any existing interval
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    let initialExpiryTime = item.workorder_expiry_time;
    let currentExpiryTime = initialExpiryTime;

    if (this.woSocketSubs) {
      this.woSocketSubs.unsubscribe();
    }
    this.woSocketSubs = this.commonService.getPublishedEvent(item._id).subscribe((result: any) => {
      this.socketData = result;
      this.getBidRate(); // Dynamically refresh L1 price on socket event
      if (this.socketData?.body?.updatedPreorderDetails?.[0]?.trip_status) {
        this.getBidList(); // Refresh bid data
      }
      // Update the currentExpiryTime with socketData value when available
      if (this.socketData?.workorder_expiry_time) {
        currentExpiryTime = this.socketData.workorder_expiry_time;
      }
      this.startCountdown(currentExpiryTime - Date.now());
    });
    this.startCountdown(initialExpiryTime - Date.now());
    this.startTimer();
    this.getTrcuksList();
    this.getBidList();
    this.getSingleWorkOrderById(this.workOrderId);
    this.wo1 = false;
    this.wo2 = true;
    this.wo3 = false;
  }

  startCountdown(timeDifference: number) {
    if (this.intervalId) {
      clearInterval(this.intervalId); // Clear existing interval
    }

    if (!timeDifference || isNaN(timeDifference) || timeDifference <= 0) {
      this.socketTimer = { remainingTime: "Expired" };
      return;
    }

    // Store the expected end time
    const endTime = Date.now() + timeDifference;

    this.intervalId = setInterval(() => {
      const currentTime = Date.now();
      const remainingTime = endTime - currentTime;

      if (remainingTime <= 0) {
        clearInterval(this.intervalId);
        this.socketTimer = { remainingTime: "Expired" };
        this.finalizingResults = true;
        setTimeout(() => {
          this.finalizingResults = false;
          this.getBidRate();
        }, 11000);
        return;
      }

      const totalMinutes = Math.floor(remainingTime / (1000 * 60));
      const seconds = Math.floor((remainingTime / 1000) % 60);
      const formattedMinutes = String(totalMinutes).padStart(2, "0");
      const formattedSeconds = String(seconds).padStart(2, "0");

      this.socketTimer = {
        remainingTime: `${formattedMinutes}:${formattedSeconds}`,
      };
    }, 1000);
  }


  openTruckDialogWithLoader(type: any, item?: any) {
    this.isAddTruckDisabled = true;
    sessionStorage.setItem("pre_order_addTruck", type);
    this.matdialogre = this.matDialog.open(PreOrderAddTruckComponent, {
      width: "40vw",
      height: "70vh",
      autoFocus: false,
      disableClose: true,
      data: {
        data: type,
        selected: this.trucksList,
        workorder_id: this.selectedData,
        item: item,
        price: this.bidRateData.bid_rate,
      },
    });

    this.matdialogre.afterClosed().subscribe((x) => {
      // Only show loader if TO actually submitted a truck
      if (x?.event === "Success") {
        this.getBidList();
        this.getTrcuksList();
        this.startAddTruckProgress(); // Start progress loader
        setTimeout(() => {
          this.getSingleWorkOrderById(this.workOrderId);
        }, 11000);
      }
    });
  }

  startAddTruckProgress() {
    this.progress = 0;
    this.isLoading = true;
    const duration = 11000; // 11 seconds
    const start = performance.now();
    const animate = (time: number) => {
      const elapsed = time - start;
      const percent = Math.min((elapsed / duration) * 100, 100);
      this.progress = percent;
      if (elapsed < duration) {
        requestAnimationFrame(animate);
      } else {
        this.isLoading = false;
        this.progress = 100;
      }
    };
    requestAnimationFrame(animate);
  }

  getRemainingTime(expiryTime: number): string {
    const now = Date.now();
    const remaining = expiryTime - now;
    if (remaining <= 0) return 'Expired';
    const minutes = Math.floor((remaining / 1000 / 60));
    const seconds = Math.floor((remaining / 1000) % 60);
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(seconds).padStart(2, '0');
    return `${paddedMinutes}:${paddedSeconds} left`;
  }

  isRankingTimeExpired(expiryTime: any): boolean {
    if (!expiryTime || isNaN(+expiryTime)) {
      return false;
    }
    return Date.now() <= +expiryTime;
  }

  isRankingTimeExpiredBtn(expiryTime: any, timerInMinutes: number): boolean {
    if (!expiryTime || isNaN(+expiryTime) || isNaN(timerInMinutes)) {
      return false;
    }
    const expiry = +expiryTime; // milliseconds
    const now = Date.now();
    const interval = timerInMinutes * 60 * 1000; // Convert minutes to milliseconds
    return now >= (expiry - interval) && now <= expiry;
  }

  openBidRateDialog(): void {
    const dialogRef = this.dialog.open(PreOrderBidRateComponent, {
      width: '30vw',
      height: 'auto',
      autoFocus: false,
      disableClose: true,
      data: {
        mode: this.submittedBidRate != null ? 'edit' : 'add',
        workorder_id: this.selectedData,
        bid_rate: this.submittedBidRate,
        bidRateId: this.bidRateData?._id,
        base_price: this.selectedWorkOrder?.base_price || this.selectedData?.base_price,
        price_per_ton: this.selectedWorkOrder?.price_per_ton || this.selectedData?.price_per_ton,
        lowest_bid_rate: this.currentLowestBidRate || this.selectedWorkOrder?.lowest_bid_rate || this.selectedData?.lowest_bid_rate
      }

    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.event === "Success") {
        this.getBidRate();
        if (result?.acceptBid) {
          this.acceptBid(this.selectedData);
        }
      }
    });
  }

  getBidRate() {
    // this.loading = true;
    this.services.getBidRate(this.token, this.workOrderId).subscribe(
      (response: any) => {
        this.submittedBidRate = response?.body?.bidRate?.bid_rate || null;
        this.lowestBidRate = response?.body?.lowestBidData?.bid_rate || null;
        this.currentLowestBidRate = response?.body?.lowest_bid_rate || null;
        this.bidRateData = response?.body?.bidRate || null;
        this.loading = false;
      },
      (error) => {
        this.loading = false;

        if (error.status === 404) {
          this.submittedBidRate = null;
          this.bidRateData = null;
          return;
        }
        if (error.error?.message === 'jwt malformed' || error.error?.message === 'jwt expired') {
          this.router.navigateByUrl('/');
          sessionStorage.clear();
          return;
        }
        this.snackBar.open(error.error.message || 'Something went wrong', 'Fail', {
          duration: 5000,
        });
      }
    );
  }

  confirmDeleteBidRate() {
    const dialogRef = this.matDialog.open(DeleteDialogComponent, {
      autoFocus: false,
      disableClose: true,
      data: { data: 'rate-delete', item: this.bidRateData },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.event === 'Success') {
        this.snackBar.open('Bid deleted successfully', 'Close', { duration: 3000 });
        this.getBidRate();
      }
    });
  }

  reject(type: any, item?: any) {
    this.MatDialogRef = this.matDialog.open(DeleteDialogComponent, {
      autoFocus: false,
      disableClose: true, // Prevents dialog from closing when clicking outside
      data: { data: type, item: item },
    });
    this.MatDialogRef.afterClosed().subscribe((x) => {
      if (x?.status != "close") {
        this.getTrcuksList();

        this.getBidList();
      }
    });
  }
  workorder() {
    this.wo3 = true;
    this.wo2 = false;
    this.wo1 = false;
    this.startTimer();
  }

  GoToProfile() {
    sessionStorage.removeItem("preorder_setting");
    sessionStorage.removeItem("preorder");
    this.router.navigateByUrl("transporter/profile");
  }

  logout() {
    sessionStorage.clear();
    this.services.logoutTransporter(this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.router.navigateByUrl("/");
          this.snackBar.open("Account logout successfully", "Success", {
            duration: 3000,
          });
        }
      },
      (error) => {
        {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
      }
    );
  }

  truckOwnerGet() {
    this.services.GettruckOwner(this.token).subscribe((response: any) => {
      this.truckOwner = response.body.data;
    });
  }

  public getProfile() {
    this.services.profileGet(this.token).subscribe((response: any) => {
      this.profilePic = response.body.data.profile_pic;
      this.userName = response.body.data.username;
    });
  }

  GoToOrders() {
    sessionStorage.removeItem("preorder");
    this.router.navigateByUrl("transporter/orders");
  }

  goToNotifications() {
    this.router.navigateByUrl("transporter/notifications");
  }

  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.preOrderList(this.workOrderId);
  }

  getTrcuksList() {
    this.isAddTruckDisabled = true; // Disable the button immediately

    this.services
      .getPreorderTrucks(this.token, this.selectedData._id)
      .subscribe((response: any) => {
        this.trucksList = response.body.data;
        this.isAddTruckDisabled = false; // Disable the button immediately

        // Delay setting isAddTruckDisabled to false by 1 second (1000 ms)
        setTimeout(() => {
          this.isAddTruckDisabled = false;
        }, 1000);
      });
  }

  getBidList() {
    // this.loading = true;
    this.bidData = [];
    this.services
      .getPreorderBidList(this.token, this.selectedData._id)
      .subscribe(
        (response: any) => {
          this.loading = false;
          this.bidData = response.body.data;
          // this.getTrcuksList();
          if (this.bidData.length != 0) {
            this.bid_list = true;
          }
        },
        (error) => {
          this.loading = false;
          this.bidData = [];

          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
        }
      );
  }
}
